// extracted by mini-css-extract-plugin
export var caretAnchor = "_vs-0";
export var dropdownContent = "_vs-1";